import { StyleSheet } from "react-native"
import { Colors, Spacing } from "@constants"

export const successLandingStyles = (isMobile: boolean) =>
  StyleSheet.create({
    main: {
      width: "100%",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: Colors.white,
      borderRadius: 12,
    },
    topView: {
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      height: 400,
      backgroundColor: Colors.lightGreen,
      width: "100%",
      borderTopStartRadius: 12,
      borderTopEndRadius: 12,
      paddingVertical: Spacing.XL,
    },
    titleContainer: {
      paddingBottom: Spacing.L,
    },
    iconContainer: {
      paddingBottom: Spacing.L,
    },
    title16: {
      textAlign: "center",
      paddingHorizontal: Spacing.L,
    },
    title16Bold: {
      textAlign: "center",
      textDecorationLine: "underline",
      paddingHorizontal: Spacing.L,
      paddingBottom: Spacing.L,
    },
    bottomView: {
      flex: 1,
      alignItems: "center",
      width: "100%",
      borderBottomStartRadius: 12,
      borderBottomEndRadius: 12,
      paddingTop: Spacing.L,
      paddingBottom: Spacing.XXL,
    },
    proposedTitle: {
      paddingBottom: Spacing.XXL,
      fontWeight: "bold",
    },
    container: {
      width: isMobile ? "100%" : "80%",
      paddingBottom: Spacing.XXXL,
      flex: 1,
    },
    iconsContainer: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
      alignContent: "center",
    },
    iconItem: {
      width: "50%",
      flexWrap: "nowrap",
      flexDirection: "row",
      alignItems: "center",
      height: 50,
      paddingVertical: Spacing.M,
    },
    iconWrapper: {
      width: "30%",
      alignItems: "center",
    },
    iconText: {
      marginLeft: Spacing.L,
      fontSize: 16,
    },
    button: {
      backgroundColor: "black",
      marginTop: Spacing.XXXL,
    },
    buttonText: {
      color: "white",
    },
  })
